export default () => {
  return {
    initial: {
      query: '',
      price_min: undefined,
      price_max: undefined,
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'accounts_marketplace::products.filters.input.label',
        placeholder: 'accounts_marketplace::products.filters.input.label',
        order: 1,
        type: 'input',
      },
      price: {
        placeholder: {
          from: 'accounts_marketplace::products.filters.dropdown.items.price.placeholders.from',
          to: 'accounts_marketplace::products.filters.dropdown.items.price.placeholders.to',
        },
        nameFrom: 'price_min',
        nameTo: 'price_max',
        subbutton: {
          isVisible: (value = {}, breakpoints) =>
            !!value.from || !!value.to || !breakpoints.fb,
        },
        label:
          'accounts_marketplace::products.filters.dropdown.items.price.label',
        position: 'dropdown',
        type: 'from-to selector',
        unit: 'USD',
      },
    },
  }
}
